var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHourglassIcon = function SvgHourglassIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    fillRule: "evenodd",
    d: "M24.905 7.92V6.653c0-1.83-1.49-3.32-3.324-3.32h-9.737a3.326 3.326 0 0 0-3.324 3.32V7.92c0 .935.394 1.824 1.076 2.437l6.132 5.636-6.134 5.638A3.35 3.35 0 0 0 8.52 24.08v1.267c0 1.83 1.492 3.32 3.324 3.32h9.737a3.325 3.325 0 0 0 3.324-3.32V24.08c0-.925-.39-1.819-1.075-2.45l-6.132-5.637 6.127-5.63a3.29 3.29 0 0 0 1.08-2.443",
    clipRule: "evenodd"
  })));
};
export default SvgHourglassIcon;